import { ListDevBoxAddOnsResponse } from '../../../data/services/data-plane-api/add-ons';
import { AggregatedResult } from '../../../models/common';
import { createActionCreator, createActionCreatorWithoutPayload } from '../core-action-creators';
import { ErrorPayload, FailedPayload, IndexedPayload } from '../core-actions';
import { DevBoxAddOnsActionType, ListAddOnsSuccessPayload } from './add-ons-actions';

/**
 * Add ons action creators
 */
export const listDevBoxAddOns = createActionCreator<IndexedPayload, ListDevBoxAddOnsResponse>(
    DevBoxAddOnsActionType.ListDevBoxAddOns,
    { async: true, startsActivity: true }
);

export const listDevBoxAddOnsError = createActionCreator<ErrorPayload & IndexedPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsError
);
export const listDevBoxAddOnsFailed = createActionCreator<FailedPayload & IndexedPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsFailed
);

export const listDevBoxAddOnsSuccess = createActionCreator<ListAddOnsSuccessPayload>(
    DevBoxAddOnsActionType.ListDevBoxAddOnsSuccess
);

export const loadDevBoxAddOnsForDevBoxes = createActionCreatorWithoutPayload<AggregatedResult>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxes,
    { async: true }
);

export const loadDevBoxAddOnsForDevBoxesError = createActionCreator<ErrorPayload>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesError
);

export const loadDevBoxAddOnsForDevBoxesFailed = createActionCreator<FailedPayload>(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesFailed
);

export const loadDevBoxAddOnsForDevBoxesSuccess = createActionCreatorWithoutPayload(
    DevBoxAddOnsActionType.LoadDevBoxAddOnsForDevBoxesSuccess
);
